import {
    GET_RPL_LIST_SUCCESS,
    GET_RPL_LIST_FAILURE,
    RplArchiveActionTypes,
    RplsListState
} from "./types"

const rplsListInitialState: RplsListState = {
    data: [],
    total: 0,
};
export function rplsList(state = rplsListInitialState, action: RplArchiveActionTypes) {
    switch (action.type) {
        case GET_RPL_LIST_SUCCESS:
            return action.payload;
        case GET_RPL_LIST_FAILURE:
            return action.payload;
        default:
            return state;
    }
}